import { EnumType } from 'json-to-graphql-query';

const date = new Date();
const year = date.getFullYear();

const filterAttributesQueries = {
  transmissionType: {
    __args: {
      order: new EnumType('alpha_asc'),
    },
    items: {
      count: true,
      label: true,
    },
  },
  financesPayment: {
    min: true,
    max: true,
  },
  financesAnnualMileage: {
    min: true,
    max: true,
    items: {
      count: true,
      label: true,
    },
  },
  financesDeposit: {
    min: true,
    max: true,
    items: {
      count: true,
      label: true,
    },
  },
  financesTerm: {
    min: true,
    max: true,
    items: {
      count: true,
      label: true,
    },
  },
  type: {
    items: {
      count: true,
      label: true,
    },
  },
  condition: {
    items: {
      count: true,
      label: true,
    },
  },
  currentPrice: {
    min: true,
    max: true,
  },
  manufacturerModel: {
    items: {
      count: true,
      label: true,
      models: {
        count: true,
        label: true,
      },
    },
  },
  modelVariant: {
    items: {
      count: true,
      label: true,
      variants: {
        count: true,
        label: true,
      },
    },
  },
  odometerKilometers: {
    __args: {
      buckets: [
        { to: 1000 },
        { to: 2000 },
        { to: 5000 },
        { to: 10000 },
        { to: 15000 },
        { to: 20000 },
        { to: 30000 },
        { to: 40000 },
        { to: 50000 },
        { to: 60000 },
        { to: 80000 },
        { to: 100000 },
      ],
    },
    items: {
      count: true,
      label: true,
    },
  },
  financesProductName: {
    items: {
      count: true,
      label: true,
    },
  },
  registrationYear: {
    __args: {
      buckets: [
        { from: year - 1 },
        { from: year - 2 },
        { from: year - 3 },
        { from: year - 4 },
        { from: year - 5 },
        { from: year - 6 },
        { from: year - 7 },
        { from: year - 8 },
        { from: year - 9 },
        { from: year - 10 },
      ],
    },
    items: {
      count: true,
      label: true,
    },
  },
  odometerMiles: {
    __args: {
      buckets: [
        { to: 1000 },
        { to: 2000 },
        { to: 5000 },
        { to: 10000 },
        { to: 15000 },
        { to: 20000 },
        { to: 30000 },
        { to: 40000 },
        { to: 50000 },
        { to: 60000 },
        { to: 80000 },
        { to: 100000 },
      ],
    },
    items: {
      count: true,
      label: true,
    },
  },
  fuelType: {
    __args: {
      order: new EnumType('alpha_asc'),
    },
    items: {
      count: true,
      label: true,
    },
  },
  bodyStyle: {
    __args: {
      order: new EnumType('alpha_asc'),
    },
    items: {
      count: true,
      label: true,
    },
  },
  genericColour: {
    __args: {
      order: new EnumType('alpha_asc'),
    },
    items: {
      count: true,
      label: true,
      englishLabel: true,
    },
  },
  numDoors: {
    items: {
      count: true,
      label: true,
    },
  },
  features: {
    items: {
      count: true,
      label: true,
    },
  },
  engineSize: {
    __args: {
      buckets: [
        { to: 1 },
        { from: 1, to: 2 },
        { from: 2, to: 3 },
        { from: 3, to: 4 },
        { from: 4, to: 5 },
        { from: 5, to: 6 },
        { from: 6 },
      ],
    },
    items: {
      count: true,
      label: true,
    },
  },
  manufacturer: {
    __args: {
      order: new EnumType('alpha_asc'),
    },
    items: {
      count: true,
      label: true,
    },
  },
  rangeKilometers: {
    __args: {
      buckets: [
        { from: 100 },
        { from: 150 },
        { from: 200 },
        { from: 250 },
        { from: 300 },
        { from: 350 },
        { from: 400 },
        { from: 450 },
      ],
    },
    items: {
      count: true,
      label: true,
    },
  },
  rangeMiles: {
    __args: {
      buckets: [
        { from: 100 },
        { from: 150 },
        { from: 200 },
        { from: 250 },
        { from: 300 },
        { from: 350 },
        { from: 400 },
        { from: 450 },
      ],
    },
    items: {
      count: true,
      label: true,
    },
  },
  locationName: {
    items: {
      count: true,
      label: true,
    },
  },
};

export default filterAttributesQueries;
